export const SHOW_COOKIE_SETTINGS = '@komigen/mobile-frontend/cookie-banner/SHOW_COOKIE_SETTINGS';
export const HIDE_COOKIE_SETTINGS = '@komigen/mobile-frontend/cookie-banner/HIDE_COOKIE_SETTINGS';
export const SHOW_COOKIE_BANNER = '@komigen/mobile-frontend/cookie-banner/SHOW_COOKIE_BANNER';
export const HIDE_COOKIE_BANNER = '@komigen/mobile-frontend/cookie-banner/HIDE_COOKIE_BANNER';
export const SET_COOKIES = '@komigen/mobile-frontend/cookie-banner/SET_COOKIES';
export const COOKIE_CATEGORIES_UPDATED = '@komigen/mobile-frontend/cookie-banner/COOKIE_CATEGORIES_UPDATED';
